export const ONBOARDING_SCREEN = "Bienvenue sur Cnarsugu";
export const TERMS_AND_CONDITIONS_SCREEN = "Conditions d'utilisation";

export const APP_STACK_SCREENS = "Cnarsugu - Accueil";

export const STEP1_SCREEN = "Accueil - Nos offres";
export const STEP2_SCREEN = "Nos Formules d'assurance";
export const COVERAGE_SCREEN = "couverture";
export const PRODUCT_SCREEN = "Produit";
export const ENROLMENT_SCREEN = "Souscription";
export const CONTACT_SCREEN = "Contact";
export const CHECKOUT_SCREEN = "Checkout";
export const CONFIRMATION_SCREEN = "Confirmation";
export const DEVIS_SCREEN = "Confirmation Devis";
export const VEHICLE_DETAILS_SCREEN = "information du vehicule";
export const TRAVEL_DETAILS_SCREEN = "informations supplémentaires - voyage";
export const TRANSPORTATION_DETAILS_SCREEN = "informations supplémentaires - transport";
export const RECEIPT_SCREEN = "Receipt";
